const basicStyle = {
    fontFamily: 'Roboto',
}

const balisesStyles = {
    defaultStyle: {
        fontSize: '11px',
        ...basicStyle
    },
    normal: {
        fontSize: '11px',
        ...basicStyle
    },
    title: {
        fontSize: '26px',
        ...basicStyle
    },
    subtitle: {
        fontSize: '15px',
        ...basicStyle
    },
    title1: {
        fontSize: '20px',
        ...basicStyle
    },
    title2: {
        fontSize: '18px',
        ...basicStyle
    },
    title3: {
        fontSize: '16px',
        ...basicStyle
    },
    title4: {
        fontSize: '14px',
        ...basicStyle
    },
    title5: {
        fontSize: '12px',
        ...basicStyle
    },
    h1: {
        fontSize: '2em',
        margin: '0',
        padding: '0',
        display: 'inline',

    },
    h2: {
        fontSize: '-1.5em',
        margin: '0',
        padding: '0',
        display: 'inline',

    },
    h3: {
        fontSize: '1.17em',
        margin: '0',
        padding: '0',
        display: 'inline',

    }
}

export default balisesStyles